export default "https://d1e6s5z4lzmgxx.cloudfront.net/9448f7a6-2ffc-48da-926d-72a27a448f00/images/more-icon.svg?8d6baef8ffbb2a52fbd89039a9b2e8ab";